module.exports = __webpack_public_path__ + "static/media/File.79102aa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/modal/templates/file_modal_popup/assets/File.svg
// module id = 572
// module chunks = 0